import { debounce } from "lodash";

const header = document.getElementById("header");
const pageTabs = document.getElementById("easy_page_tabs");

export function initUIHelpers() {
  if (header) initHeaderResizeObserver();
  if (pageTabs) setSidebarCustomProps();
}

const initHeaderResizeObserver = (): ResizeObserver => {
  const resizeObserverCallback: ResizeObserverCallback = debounce(() => {
    window.affix.reInit();
    setHeaderCustomProps();
  }, 100) as ResizeObserverCallback;

  const headerResizeObserver = new ResizeObserver(resizeObserverCallback);
  headerResizeObserver.observe(header!);
  return headerResizeObserver;
};

const setSidebarCustomProps = () => {
  createVarCssProperty("--easy__page_tabs-height", `${pageTabs!.offsetHeight}px`);
};

const setHeaderCustomProps = () => {
  //set content position css property for sticky positioning
  createVarCssProperty("--easy__header-height", `${header!.offsetHeight}px`);
};

const varStyleElements = new Map<string, HTMLStyleElement>();

const createVarCssProperty = (name: string, value: string) => {
  const css = `:root { ${name}: ${value} }`;
  const head = document.head || document.getElementsByTagName("head")[0];
  let style = varStyleElements.get(name);

  if (!style) {
    style = document.createElement("style");
    varStyleElements.set(name, style);
  } else if (style.textContent === css && style.isConnected && head.lastElementChild === style) {
    return;
  }

  style.textContent = css;
  head.appendChild(style);
};

export const getCssVarPropertyValue = (varName: string): string => {
  return getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
};

export const queryLastElementById = (elementId: string): HTMLElement => {
  const elements = document.body.querySelectorAll(`#${elementId}`);
  return elements[elements.length - 1] as HTMLElement;
};

export const getElementHeight = (selector: string): number => {
  const element = document.querySelector<HTMLElement>(selector);
  return element ? element.offsetHeight : 0;
};

export const getRootComputedStyleValue = (propertyName: string): number => {
  const value = window.getComputedStyle(document.documentElement).getPropertyValue(propertyName);
  return parseInt(value) || 0;
};
